import { IHomePage } from "@/cms-models/home";
import axios from "axios";
import { NextRouter, useRouter } from "next/router";
import { useEffect, useState } from "react";
import { RealStoriesSection } from "../home";
import { LanguageCode } from "@/utils";

interface VeterinaryExcellenceSectionProps {
  locale?: LanguageCode;
}

export const VeterinaryExcellenceSection = ({ locale }: VeterinaryExcellenceSectionProps) => {
  const router: NextRouter = useRouter();
  const [data, setData] = useState<IHomePage>({} as IHomePage);
  
  useEffect(() => {
    (async () => {
      try {
        // Use provided locale or fallback to router.locale or default
        const currentLocale = locale || router.locale || 'en-us';
        const response = await axios(`/${currentLocale==='en-us'? 'en' : currentLocale}/homepage-content/1`);
        if (response.status === 200) {
          setData(response.data);
        }
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
      } catch (error) {
        // Handle error silently
      }
    })();
  }, [router.locale, locale]);

  return (
    <section className="container mx-auto pb-20">
      <RealStoriesSection data={data} />
    </section>
  )
}
